var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4447 2.1665H7.77799C7.40956 2.1665 7.11133 2.45728 7.11133 2.8165C7.11133 3.17573 7.40956 3.4665 7.77799 3.4665H10.4447C10.8131 3.4665 11.1113 3.17573 11.1113 2.8165C11.1113 2.45728 10.8131 2.1665 10.4447 2.1665Z",
    fill: "#FF0990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H2.66667C1.19646 0 0 1.16655 0 2.6V23.4C0 24.8335 1.19646 26 2.66667 26H13.3333C14.8035 26 16 24.8335 16 23.4V2.6C16 1.16655 14.8035 0 13.3333 0ZM14.6667 23.4C14.6667 24.118 14.0698 24.7 13.3333 24.7H2.66667C1.93021 24.7 1.33333 24.118 1.33333 23.4V2.6C1.33333 1.88195 1.93021 1.3 2.66667 1.3H13.3333C14.0698 1.3 14.6667 1.88195 14.6667 2.6V23.4Z",
    fill: "#FF0990"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 23.8334C8.73768 23.8334 9.33464 23.2514 9.33464 22.5334C9.33464 21.8154 8.73768 21.2334 8.0013 21.2334C7.26492 21.2334 6.66797 21.8154 6.66797 22.5334C6.66797 23.2514 7.26492 23.8334 8.0013 23.8334Z",
    fill: "#FF0990"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55534 3.4665C5.92353 3.4665 6.22201 3.17549 6.22201 2.8165C6.22201 2.45752 5.92353 2.1665 5.55534 2.1665C5.18715 2.1665 4.88867 2.45752 4.88867 2.8165C4.88867 3.17549 5.18715 3.4665 5.55534 3.4665Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.87ef8c92943f9e15ed88c3a0f4116b84.svg";
export { ForwardRef as ReactComponent };